(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blinx-product"] && !Shopify.designMode) return;
  try {
    
  /* Size logic, kept free of the DOM so it can be tested on its own. */
  const BxFit = {
    IN: 2.54,
    LB: 0.45359237,

    /* "XXL" and "2XL" are the same size. */
    norm(label) {
      let text = String(label == null ? '' : label).trim().toUpperCase().replace(/\s+/g, '');
      const match = text.match(/^(X{2,})([SL])$/);
      if (match) text = match[1].length + 'X' + match[2];
      return text;
    },

    num(raw) {
      const text = String(raw == null ? '' : raw).trim().replace(',', '.');
      if (!/^\d+(\.\d+)?$/.test(text)) return NaN;
      return parseFloat(text);
    },

    list(raw) {
      return String(raw || '').split(',').map((part) => parseFloat(part)).filter((value) => !Number.isNaN(value));
    },

    range(raw) {
      const text = String(raw || '').replace(/[–—]/g, '-').replace(/\s+/g, '');
      let match = text.match(/^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)$/);
      if (match) return [parseFloat(match[1]), parseFloat(match[2])];
      match = text.match(/^(\d+(?:\.\d+)?)\+$/);
      if (match) return [parseFloat(match[1]), Infinity];
      return null;
    },

    /* One row per line: "Size | min-max | min-max (optional second measurement) | US size (optional)". */
    parseTable(raw, sizes) {
      const known = (sizes || []).map((size) => BxFit.norm(size));
      const rows = [];
      String(raw || '').split('\n').forEach((line) => {
        const parts = line.split('|').map((part) => part.trim());
        if (parts.length < 2 || !parts[0]) return;
        const a = BxFit.range(parts[1]);
        if (!a) return;
        const row = { label: parts[0], key: BxFit.norm(parts[0]), a, b: null, us: '' };
        /* A part starting with a letter ("US 4-6") is the usual clothing size, shown in the chart only. */
        parts.slice(2).forEach((part) => {
          if (!part) return;
          if (/^[a-z]/i.test(part)) row.us = part.replace(/^us\s*/i, '');
          else if (!row.b) row.b = BxFit.range(part);
        });
        if (known.length) {
          const index = known.indexOf(row.key);
          if (index < 0) return;
          row.label = sizes[index];
        }
        rows.push(row);
      });
      return rows;
    },

    /* Reads a body length. Works out the unit when the number can only be the other one. */
    readLength(raw, unit) {
      const value = BxFit.num(raw);
      if (Number.isNaN(value)) return { error: 'empty' };
      const okIn = value >= 18 && value <= 80;
      const okCm = value >= 46 && value <= 203;
      let used = unit;
      if (unit === 'in' && !okIn) used = okCm ? 'cm' : null;
      if (unit === 'cm' && !okCm) used = okIn ? 'in' : null;
      if (!used) return { error: 'range' };
      const inches = used === 'in' ? value : value / BxFit.IN;
      return { in: inches, cm: inches * BxFit.IN, unit: used, switched: used !== unit, typed: value };
    },

    readWeight(raw, unit) {
      const value = BxFit.num(raw);
      if (Number.isNaN(value)) return { error: 'empty' };
      const okLb = value >= 70 && value <= 500;
      const okKg = value >= 32 && value <= 227;
      let used = unit;
      if (unit === 'lb' && !okLb) used = okKg ? 'kg' : null;
      if (unit === 'kg' && !okKg) used = okLb ? 'lb' : null;
      if (!used) return { error: 'range' };
      const lb = used === 'lb' ? value : value / BxFit.LB;
      return { lb, kg: lb * BxFit.LB, unit: used, switched: used !== unit, typed: value };
    },

    /* A length in the unit the table is written in. Converted values snap to the nearest half unit,
       so 69 cm on an inch table reads as 27 in, the same row the cm version of the chart shows. */
    native(length, tableUnit) {
      if (length.unit === tableUnit) return length.typed;
      const value = tableUnit === 'in' ? length.in : length.cm;
      return Math.round(value * 2) / 2;
    },

    /* Finds the row for one measurement. Never rounds down:
       - on a line shared by two sizes, the larger size wins;
       - in a gap between two rows, the next size up wins. */
    pick(rows, key, value) {
      const last = rows.length - 1;
      if (value < rows[0][key][0]) return { index: 0, status: 'below' };
      if (value > rows[last][key][1]) return { index: last, status: 'above' };
      for (let i = 0; i <= last; i += 1) {
        const min = rows[i][key][0];
        const max = rows[i][key][1];
        if (value >= min && value < max) return { index: i, status: 'in', position: max === Infinity ? 0 : (value - min) / (max - min) };
        if (value === max) {
          for (let j = i + 1; j <= last; j += 1) {
            if (rows[j][key][0] === max && rows[j][key][1] !== max) return { index: j, status: 'edge', lower: i, position: 0 };
          }
          return { index: i, status: 'in', position: 1 };
        }
      }
      for (let i = 0; i <= last; i += 1) {
        if (rows[i][key][0] > value) return { index: i, status: 'between', lower: i - 1, position: 0 };
      }
      return { index: last, status: 'above' };
    },

    /* Chart with one or two measurements. The larger of the two results wins. */
    fromChart(rows, a, b) {
      const first = BxFit.pick(rows, 'a', a);
      const useB = b != null && rows.every((row) => row.b);
      const second = useB ? BxFit.pick(rows, 'b', b) : null;
      if (first.status === 'above' || (second && second.status === 'above')) {
        return { status: 'above', index: rows.length - 1, driver: first.status === 'above' ? 'a' : 'b', first, second };
      }
      let driver = 'a';
      let chosen = first;
      if (second && second.index > first.index) {
        driver = 'b';
        chosen = second;
      }
      return { status: chosen.status, index: chosen.index, lower: chosen.lower, position: chosen.position, driver, first, second, raised: driver === 'b' };
    },

    /* Height and weight give the base size. A bust measurement can only move it up, never down. */
    fromBody(config, heightIn, lb, bustIn) {
      const weights = config.weights;
      let base = 0;
      while (base < weights.length && lb > weights[base]) base += 1;
      const tall = config.tall;
      if (tall.length === 2 && heightIn >= tall[0] && base <= tall[1]) base += 1;
      let index = base;
      let bustIndex = null;
      if (bustIn != null) {
        bustIndex = 0;
        while (bustIndex < config.bust.length && bustIn >= config.bust[bustIndex]) bustIndex += 1;
        index = Math.max(base, bustIndex);
      }
      const last = config.sizes.length - 1;
      const capped = index > last;
      if (capped) index = last;
      const far = index === last && ((bustIn != null && config.bust.length && bustIn >= config.bust[config.bust.length - 1] + 3) || lb > weights[weights.length - 1] + 40);
      return { status: 'in', index, base, bustIndex, raised: bustIndex != null && bustIndex > base, top: capped || far };
    },
  };

  class BxBuyBox extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-form]');
      if (!this.form) return;
      const read = (selector, fallback) => {
        try {
          return JSON.parse(this.querySelector(selector).textContent);
        } catch (err) {
          return fallback;
        }
      };
      this.variants = read('[data-variants]', []);
      this.optionNames = read('[data-option-names]', []);
      this.swatches = this.parseSwatches(read('[data-swatch-map]', ''));
      this.colorPosition = Number(this.dataset.colorPosition || 0);
      this.sizePosition = Number(this.dataset.sizePosition || 0);
      this.variantInput = this.querySelector('[data-variant-input]');
      this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
      this.submitButtons = Array.from(this.querySelectorAll('[data-submit]'));
      this.unitsEl = this.querySelector('[data-units]');
      /* Mix and match: each item of a bundle can be another style of the same type. */
      this.handle = this.dataset.handle || '';
      this.pool = {};
      read('[data-mix]', []).forEach((item) => {
        if (item && item.handle && Array.isArray(item.variants) && item.variants.length) this.pool[item.handle] = item;
      });
      const ownImage = this.querySelector('[data-gallery] img');
      if (!this.pool[this.handle]) this.pool[this.handle] = { handle: this.handle, title: this.dataset.title || '', image: '', variants: this.variants };
      this.pool[this.handle].variants = this.variants;
      if (!this.pool[this.handle].image && ownImage) this.pool[this.handle].image = (ownImage.currentSrc || ownImage.src || '');
      this.mixOn = Object.keys(this.pool).length > 1;
      /* With bundles, every item gets its own color and size row inside the selected bundle card. */
      this.inline = this.tiers.length > 0 && this.optionNames.length > 0 && !(this.optionNames.length === 1 && this.optionNames[0] === 'Title');
      /* Without bundles, units[0] mirrors the main pickers. */
      this.units = [this.inline ? this.blankUnit() : this.readMainOptions()];
      this.touched = [true];

      this.paintSwatches(this);
      this.tiers.forEach((input) => input.addEventListener('change', () => this.update()));
      this.querySelectorAll('[data-option-input]').forEach((input) => {
        input.addEventListener('change', () => {
          this.units[0] = this.readMainOptions();
          this.update(true);
        });
      });
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      // Apps (cart upsell drawers) hijack native product-form submits and post only the single variant.
      // Our buttons become plain buttons so only our pack/bundle logic adds to cart.
      const ownSubmit = (event) => { event.preventDefault(); event.stopImmediatePropagation(); this.onSubmit(event); };
      const submitButtons = new Set([...this.querySelectorAll('[data-submit], [data-sticky-submit]')]);
      if (this.form.id) document.querySelectorAll(`[form="${this.form.id}"]`).forEach((b) => submitButtons.add(b));
      submitButtons.forEach((button) => { button.type = 'button'; button.addEventListener('click', ownSubmit, true); });
      this.form.addEventListener('submit', ownSubmit, true);

      this.initFit();
      this.update();
      this.initGallery();
      this.initZoom();
      this.initSticky();
      this.initShipDate();
      this.initCountdown();
    }

    parseSwatches(raw) {
      const map = {};
      String(raw || '').split('\n').forEach((line) => {
        const index = line.lastIndexOf(':');
        if (index < 1) return;
        map[line.slice(0, index).trim().toLowerCase()] = line.slice(index + 1).trim();
      });
      return map;
    }

    swatchColor(value) {
      return this.swatches[String(value).trim().toLowerCase()] || '';
    }

    paintSwatches(root) {
      root.querySelectorAll('[data-swatch]').forEach((chip) => {
        const color = this.swatchColor(chip.dataset.swatch);
        if (color) chip.style.background = color;
      });
    }

    /* A new row: first value of every option, except size which the shopper must choose. */
    blankUnit() {
      const base = this.variants.find((variant) => variant.available) || this.variants[0];
      const unit = this.optionNames.map((name, index) => {
        if (index === this.sizePosition - 1) return null;
        return base ? base.options[index] : null;
      });
      unit.style = this.handle;
      return unit;
    }

    cloneUnit(unit) {
      const copy = unit.slice();
      copy.style = unit.style;
      return copy;
    }

    variantsFor(style) {
      return style && this.pool && this.pool[style] ? this.pool[style].variants : this.variants;
    }

    optionValues(index) {
      const values = [];
      const hidden = index === this.sizePosition - 1 ? (this.dataset.hideSizes || '').split(',').map((v) => v.trim()).filter(Boolean) : [];
      this.variants.forEach((variant) => {
        if (!values.includes(variant.options[index]) && !hidden.includes(variant.options[index])) values.push(variant.options[index]);
      });
      return values;
    }

    renderRows(count) {
      while (this.units.length < count) {
        this.units.push(this.cloneUnit(this.units[0]));
      }
      this.units.length = count;
      /* Same-variant mode (lots): one size picker, every unit copies it. */
      const same = this.dataset.same === 'true';
      if (same) {
        for (let i = 1; i < count; i += 1) {
          const copy = this.units[0].slice();
          copy.style = this.units[0].style;
          this.units[i] = copy;
        }
      }
      const active = this.tier.input;
      /* Rows are rebuilt on every change, so keyboard focus is put back where it was. */
      const focused = document.activeElement && document.activeElement.closest ? document.activeElement.closest('.bx-row') : null;
      let refocus = null;
      if (focused && this.contains(focused)) {
        const rows = Array.from(focused.parentNode.querySelectorAll('.bx-row'));
        refocus = { row: rows.indexOf(focused), color: document.activeElement.hasAttribute('data-row-color'), style: document.activeElement.hasAttribute('data-row-style'), option: document.activeElement.dataset.rowOption };
      }
      this.tiers.forEach((input) => {
        const holder = input.closest('.mp-tier').querySelector('[data-tier-rows]');
        if (!holder) return;
        holder.textContent = '';
        if (input !== active) return;
        if (this.fit) {
          const head = document.createElement('div');
          head.className = 'bx-rows__head';
          const hint = document.createElement('span');
          const picks = this.mixOn ? 'le modèle' : this.colorPosition > 0 ? 'la couleur' : '';
          hint.textContent = picks
            ? (this.units.length > 1 ? 'Choisis ' + picks + ' et taille pour chacune' : 'Choisis ' + picks + ' et taille')
            : (this.units.length > 1 && !same ? 'Choisis la taille de chacune' : 'Choisis ta taille');
          const link = document.createElement('button');
          link.type = 'button';
          link.className = 'bx-fit-link' + (this.fitSize ? ' is-done' : '');
          link.dataset.fitOpen = '';
          link.setAttribute('aria-haspopup', 'dialog');
          link.textContent = this.fitSize ? 'Ta taille : ' + this.fitSize : this.fitLabel || 'Trouver ma taille';
          head.appendChild(hint);
          head.appendChild(link);
          holder.appendChild(head);
        }
        if (same) holder.appendChild(this.buildSizePills(this.units[0]));
        else this.units.forEach((unit, i) => holder.appendChild(this.buildRow(unit, i)));
        if (refocus) {
          const row = holder.querySelectorAll('.bx-row')[refocus.row];
          const target = row ? row.querySelector(refocus.style ? '[data-row-style]' : refocus.color ? '[data-row-color]' : '[data-row-option="' + refocus.option + '"]') : null;
          if (target) target.focus({ preventScroll: true });
        }
      });
    }

    /* Lots: one tap-to-pick size grid (no dropdown). Other options keep their dropdown. */
    buildSizePills(unit) {
      const wrap = document.createElement('div');
      wrap.className = 'bxsz';
      const index = this.sizePosition - 1;
      const others = this.optionNames.map((n, k) => k).filter((k) => k !== index);
      if (index < 0 || others.length) {
        wrap.appendChild(this.buildRow(unit, 0));
        if (index < 0) return wrap;
      }
      const grid = document.createElement('div');
      grid.className = 'bxsz__grid' + (unit[index] === null && this.showMissing ? ' is-missing' : '');
      grid.setAttribute('role', 'radiogroup');
      grid.setAttribute('aria-label', this.optionNames[index] || 'Taille');
      this.optionValues(index).forEach((value) => {
        const probe = this.cloneUnit(unit);
        probe[index] = value;
        const variant = this.findVariant(probe, probe.style);
        const soldOut = !variant || !variant.available;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bxsz__pill' + (value === unit[index] ? ' is-on' : '') + (soldOut ? ' is-out' : '') + (this.fitSize === value ? ' is-fit' : '');
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', value === unit[index] ? 'true' : 'false');
        btn.disabled = soldOut;
        btn.textContent = value;
        if (soldOut) btn.title = 'Épuisée';
        btn.addEventListener('click', () => {
          this.units.forEach((other) => (other[index] = value));
          this.update();
        });
        grid.appendChild(btn);
      });
      wrap.appendChild(grid);
      return wrap;
    }

    buildRow(unit, i) {
      const row = document.createElement('div');
      row.className = 'bx-row';
      const number = document.createElement('span');
      number.className = 'bx-row__n';
      number.textContent = '#' + (i + 1);
      row.appendChild(number);

      const colorIndex = this.colorPosition - 1;
      if (this.mixOn) {
        const styles = Object.values(this.pool);
        const current = this.pool[unit.style] || this.pool[this.handle];
        if (current && current.image) {
          const thumb = document.createElement('img');
          thumb.className = 'bx-row__thumb';
          thumb.src = current.image;
          thumb.alt = '';
          thumb.width = 40;
          thumb.height = 40;
          row.appendChild(thumb);
        }
        const wrap = document.createElement('span');
        wrap.className = 'bx-row__color bx-row__style';
        const styleSelect = document.createElement('select');
        styleSelect.className = 'bx-row__select';
        styleSelect.dataset.rowStyle = '';
        styleSelect.setAttribute('aria-label', (this.dataset.styleLabel || 'Style') + ' for item ' + (i + 1));
        styles.forEach((item) => {
          const option = document.createElement('option');
          option.value = item.handle;
          option.textContent = item.title;
          option.selected = item.handle === unit.style;
          styleSelect.appendChild(option);
        });
        styleSelect.addEventListener('change', () => {
          unit.style = styleSelect.value;
          this.update();
        });
        wrap.appendChild(styleSelect);
        row.appendChild(wrap);
      } else if (colorIndex >= 0) {
        const image = this.colorImage(unit[colorIndex]);
        if (image) {
          const thumb = document.createElement('img');
          thumb.className = 'bx-row__thumb';
          thumb.src = image;
          thumb.alt = '';
          thumb.width = 40;
          thumb.height = 40;
          row.appendChild(thumb);
        }
        /* One dropdown per item keeps the row short, whatever the number of colors. */
        const wrap = document.createElement('span');
        wrap.className = 'bx-row__color';
        const swatch = document.createElement('span');
        swatch.className = 'bx-row__swatch';
        const fill = this.swatchColor(unit[colorIndex]);
        if (fill) swatch.style.background = fill;
        const colorSelect = document.createElement('select');
        colorSelect.className = 'bx-row__select';
        colorSelect.dataset.rowColor = '';
        colorSelect.setAttribute('aria-label', this.optionNames[colorIndex] + ' for item ' + (i + 1));
        this.optionValues(colorIndex).forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          option.selected = value === unit[colorIndex];
          colorSelect.appendChild(option);
        });
        colorSelect.addEventListener('change', () => {
          unit[colorIndex] = colorSelect.value;
          this.update();
          this.lastColor = null;
          this.showColor(colorSelect.value);
        });
        wrap.appendChild(swatch);
        wrap.appendChild(colorSelect);
        row.appendChild(wrap);
      }

      this.optionNames.forEach((name, optionIndex) => {
        if (optionIndex === colorIndex) return;
        const select = document.createElement('select');
        select.className = 'bx-row__select';
        select.dataset.rowOption = String(optionIndex);
        select.setAttribute('aria-label', name + ' for item ' + (i + 1));
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = name;
        placeholder.disabled = true;
        placeholder.selected = unit[optionIndex] === null;
        select.appendChild(placeholder);
        this.optionValues(optionIndex).forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          const probe = this.cloneUnit(unit);
          probe[optionIndex] = value;
          const variant = this.findVariant(probe, probe.style);
          const soldOut = !variant || !variant.available;
          option.textContent = value + (soldOut ? ' (Rupture de stock)' : '');
          option.disabled = soldOut;
          option.selected = value === unit[optionIndex];
          select.appendChild(option);
        });
        if (unit[optionIndex] === null && this.showMissing) select.classList.add('is-missing');
        select.addEventListener('change', () => {
          unit[optionIndex] = select.value;
          /* Choosing on the first item fills the items that have no choice yet. */
          if (i === 0) {
            this.units.forEach((other) => {
              if (other[optionIndex] === null) other[optionIndex] = select.value;
            });
          }
          this.update();
        });
        row.appendChild(select);
      });
      return row;
    }

    unitComplete(unit) {
      return unit.every((value) => value !== null && value !== '');
    }

    readMainOptions() {
      return this.optionNames.map((name, index) => {
        const checked = this.querySelector('[data-option="' + (index + 1) + '"] [data-option-input]:checked');
        if (checked) return checked.value;
        const base = this.variants.find((variant) => variant.available) || this.variants[0];
        return base ? base.options[index] : null;
      });
    }

    findVariant(options, style) {
      return this.variantsFor(style).find((variant) => variant.options.every((value, index) => value === options[index]));
    }

    get tier() {
      const input = this.tiers.find((item) => item.checked) || this.tiers[0];
      if (!input) return { units: 1, payUnits: 1, title: '' };
      return { units: Number(input.dataset.units || 1), payUnits: Number(input.dataset.payUnits || 1), title: input.dataset.title || '', input };
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(this.dataset.locale || undefined, { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
      } catch (err) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
      }
    }

    /* Greys out option values that are sold out with the rest of unit 1's selection. */
    markAvailability() {
      if (this.inline) return;
      const current = this.units[0];
      this.querySelectorAll('[data-option]').forEach((fieldset) => {
        const index = Number(fieldset.dataset.option) - 1;
        fieldset.querySelectorAll('[data-option-input]').forEach((input) => {
          const probe = current.slice();
          probe[index] = input.value;
          const variant = this.findVariant(probe);
          input.closest('label').classList.toggle('is-unavailable', !variant || !variant.available);
        });
        const label = fieldset.querySelector('[data-option-value]');
        if (label) label.textContent = current[index] || '';
        fieldset.querySelectorAll('[data-bundle]').forEach((input) => {
          const card = input.closest('.mp-tier');
          card.classList.toggle('is-selected', input.checked);
          const probe = current.slice();
          probe[index] = input.value;
          const variant = this.findVariant(probe);
          if (!variant) return;
          /* "3-Pack (Buy 2 Get 1)" holds 3 units; "1 Pair" holds 1. */
          const count = parseInt(input.value, 10) || 1;
          const priceEl = card.querySelector('[data-bundle-price]');
          const compareEl = card.querySelector('[data-bundle-compare]');
          const unitEl = card.querySelector('[data-bundle-unit]');
          const saveEl = card.querySelector('[data-bundle-save]');
          priceEl.textContent = this.money(variant.price);
          const hasCompare = variant.compare > variant.price;
          compareEl.hidden = !hasCompare;
          compareEl.textContent = this.money(variant.compare);
          saveEl.hidden = !hasCompare;
          if (hasCompare) saveEl.textContent = '−' + Math.round(((variant.compare - variant.price) / variant.compare) * 100) + ' %';
          unitEl.hidden = count < 2;
          unitEl.textContent = this.money(Math.round(variant.price / count)) + ' / ' + (this.dataset.unitLabel || 'item');
        });
      });
    }

    renderUnits(count) {
      if (this.inline) {
        this.renderRows(count);
        return;
      }
      while (this.units.length < count) {
        this.units.push(this.units[0].slice());
        this.touched.push(false);
      }
      this.units.length = count;
      this.touched.length = count;
      for (let i = 1; i < count; i += 1) {
        if (!this.touched[i]) this.units[i] = this.units[0].slice();
      }

      if (!this.unitsEl) return;
      const heading = this.querySelector('[data-unit-heading]');
      if (heading) heading.hidden = count < 2;
      this.unitsEl.hidden = count < 2;
      this.unitsEl.textContent = '';
      if (count < 2) return;

      const unitLabel = this.dataset.unitLabel || 'item';
      const payUnits = this.tier.payUnits;
      for (let i = 1; i < count; i += 1) {
        const row = document.createElement('div');
        row.className = 'bx-unit';
        const label = document.createElement('span');
        label.className = 'bx-unit__label';
        const chip = document.createElement('span');
        chip.className = 'bx-unit__chip';
        if (this.colorPosition > 0) {
          const colorName = this.units[i][this.colorPosition - 1];
          const image = this.colorImage(colorName);
          if (image) {
            const thumb = document.createElement('img');
            thumb.className = 'bx-unit__thumb';
            thumb.src = image;
            thumb.alt = '';
            thumb.width = 36;
            thumb.height = 36;
            label.appendChild(thumb);
          } else {
            const color = this.swatchColor(colorName);
            if (color) chip.style.background = color;
            label.appendChild(chip);
          }
        }
        const text = document.createElement('span');
        text.textContent = unitLabel.charAt(0).toUpperCase() + unitLabel.slice(1) + ' ' + (i + 1);
        label.appendChild(text);
        if (i >= payUnits) {
          const free = document.createElement('span');
          free.className = 'bx-unit__free';
          free.textContent = 'FREE';
          label.appendChild(free);
        }
        row.appendChild(label);

        this.optionNames.forEach((name, optionIndex) => {
          const select = document.createElement('select');
          select.setAttribute('aria-label', text.textContent + ' ' + name);
          const values = [];
          this.variants.forEach((variant) => {
            if (!values.includes(variant.options[optionIndex])) values.push(variant.options[optionIndex]);
          });
          values.forEach((value) => {
            const option = document.createElement('option');
            option.value = value;
            const probe = this.units[i].slice();
            probe[optionIndex] = value;
            const variant = this.findVariant(probe);
            option.textContent = value + (variant && variant.available ? '' : ' (Rupture de stock)');
            option.selected = value === this.units[i][optionIndex];
            select.appendChild(option);
          });
          select.addEventListener('change', () => {
            this.units[i][optionIndex] = select.value;
            this.touched[i] = true;
            this.update();
          });
          row.appendChild(select);
        });
        const variant = this.findVariant(this.units[i]);
        row.classList.toggle('is-soldout', !variant || !variant.available);
        this.unitsEl.appendChild(row);
      }
    }

    update(fromMain) {
      const tier = this.tier;
      this.tiers.forEach((input) => input.closest('.mp-tier').classList.toggle('is-selected', input === tier.input));
      this.markAvailability();
      this.renderUnits(tier.units);

      const chosen = this.units.map((options) => this.findVariant(options, options.style));
      const main = chosen.find(Boolean);
      const complete = this.units.every((unit) => this.unitComplete(unit));
      const soldOut = this.units.some((unit, i) => this.unitComplete(unit) && (!chosen[i] || !chosen[i].available));
      const allAvailable = !soldOut;
      if (main) this.variantInput.value = main.id;
      const fallback = this.variants.length ? this.variants[0] : { price: 0, compare: 0 };

      /* Paid units are the most expensive ones, matching how Shopify applies Buy X Get Y. */
      const prices = chosen.map((variant) => (variant || fallback).price).sort((a, b) => b - a);
      /* Amount-off bundles: the discount is set in the store currency, so it follows the exchange rate. */
      const rate = window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate) > 0 ? Number(window.Shopify.currency.rate) : 1;
      const offOf = (input) => Math.round(Number((input && input.dataset.off) || 0) * rate);
      const fixedTotal = offOf(tier.input);
      /* Percentage bundles: the same share comes off in every currency, so page and cart always agree. */
      const keepOf = (input) => 1 - Math.min(100, Math.max(0, Number((input && input.dataset.percent) || 0))) / 100;
      const total = Math.max(0, Math.round(prices.slice(0, tier.payUnits).reduce((sum, value) => sum + value, 0) * keepOf(tier.input)) - fixedTotal);

      this.tiers.forEach((input) => {
        const units = Number(input.dataset.units || 1);
        const payUnits = Number(input.dataset.payUnits || 1);
        const fixed = offOf(input);
        const baseVariant = main || fallback;
        const base = baseVariant.price;
        const compareBase = baseVariant.compare > baseVariant.price ? baseVariant.compare : base;
        const card = input.closest('.mp-tier');
        const price = input === tier.input ? total : Math.max(0, Math.round(base * payUnits * keepOf(input)) - fixed);
        const compare = compareBase * units;
        const priceEl = card.querySelector('[data-tier-price]');
        const compareEl = card.querySelector('[data-tier-compare]');
        const unitEl = card.querySelector('[data-tier-unit]');
        if (priceEl) priceEl.textContent = this.money(price);
        if (compareEl) {
          compareEl.hidden = compare <= price;
          compareEl.textContent = this.money(compare);
        }
        if (unitEl) {
          const perUnits = units * (Number(this.dataset.packSize) || 1);
          unitEl.hidden = perUnits < 2;
          unitEl.textContent = this.money(Math.round(price / perUnits)) + ' / ' + (this.dataset.unitLabel || 'item');
        }
      });

      if (this.colorPosition > 0) {
        const mainImage = this.colorImage(this.units[0][this.colorPosition - 1]);
        if (mainImage) this.querySelectorAll('[data-tier-thumb]').forEach((img) => { img.removeAttribute('srcset'); img.src = mainImage; });
      }

      const label = this.querySelector('[data-submit-label]');
      const priceEl = this.querySelector('[data-submit-price]');
      this.complete = complete;
      if (complete && this.showMissing) {
        this.showMissing = false;
        const error = this.querySelector('[data-error]');
        if (error) error.hidden = true;
      }
      if (label) label.textContent = allAvailable ? label.dataset.label : label.dataset.soldout;
      if (priceEl) priceEl.textContent = allAvailable ? '– ' + this.money(total) : '';
      this.submitButtons.forEach((button) => (button.disabled = !allAvailable));
      const note = this.querySelector('[data-discount-note]');
      if (note) note.hidden = tier.payUnits >= tier.units && fixedTotal === 0 && keepOf(tier.input) === 1;
      /* Gifts unlock with the number of items: bundle units, or the pack size ("3-Pack" = 3). */
      const packInput = this.querySelector('[data-bundle]:checked');
      const count = this.tiers.length ? tier.units : packInput ? parseInt(packInput.value, 10) || 1 : 1;
      this.querySelectorAll('[data-gift]').forEach((gift) => {
        const min = Number(gift.dataset.min || 1);
        const locked = count < min;
        gift.classList.toggle('is-locked', locked);
        const state = gift.querySelector('[data-gift-state]');
        if (state) state.textContent = locked ? String(state.dataset.locked || '').replace('[n]', min) : state.dataset.free;
      });
      const stickyPrice = this.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = (tier.title ? tier.title + ' · ' : '') + this.money(total);

      if (fromMain && main) {
        if (main.media) this.showMedia(main.media);
        else if (this.colorPosition > 0) this.showColor(main.options[this.colorPosition - 1]);
      }
    }

    initFit() {
      const dialog = this.querySelector('[data-fit]');
      if (!dialog) return;
      const disable = (reason) => {
        this.querySelectorAll('[data-fit-open]').forEach((button) => (button.hidden = true));
        if (window.console) console.warn('Blinx size finder is off: ' + reason);
      };
      let config = null;
      try {
        config = JSON.parse(this.querySelector('[data-fit-config]').textContent);
      } catch (err) {
        config = null;
      }
      if (!config) return disable('no settings');

      const fit = { mode: config.mode, tableUnit: config.unit === 'cm' ? 'cm' : 'in', unit: 'cm', weightUnit: 'kg', chartUnit: 'cm', sizes: config.sizes || [], result: null };
      if (fit.mode === 'body') {
        fit.body = { weights: BxFit.list(config.weights), tall: BxFit.list(config.tall), bust: BxFit.list(config.bust), sizes: fit.sizes };
        /* One step between each pair of sizes, or the answer could point at the wrong size. */
        if (fit.sizes.length < 2 || fit.body.weights.length !== fit.sizes.length - 1) return disable('weight steps do not match the sizes');
        if (fit.body.bust.length && fit.body.bust.length !== fit.sizes.length - 1) return disable('bust steps do not match the sizes');
      } else {
        fit.rows = BxFit.parseTable(config.table, fit.sizes);
        if (fit.rows.length < 2) return disable('size table has fewer than two usable rows');
        for (let i = 1; i < fit.rows.length; i += 1) {
          if (fit.rows[i].a[0] < fit.rows[i - 1].a[0]) return disable('size table is not in ascending order');
        }
        if (fit.rows.some((row) => row.b) && !fit.rows.every((row) => row.b)) fit.rows.forEach((row) => (row.b = null));
        const missing = fit.sizes.filter((size) => !fit.rows.some((row) => row.key === BxFit.norm(size)));
        if (missing.length && window.console) console.warn('Blinx size finder: no chart row for ' + missing.join(', '));
      }
      this.fit = fit;
      const firstLabel = this.querySelector('[data-fit-label]');
      this.fitLabel = (firstLabel && firstLabel.dataset.default) || dialog.querySelector('.bx-fit__title').textContent.trim();

      const find = dialog.querySelector('[data-fit-pane="find"]');
      const chart = dialog.querySelector('[data-fit-pane="chart"]');
      const resultEl = dialog.querySelector('[data-fit-result]');
      const applyButton = dialog.querySelector('[data-fit-apply]');
      const inputA = dialog.querySelector('[data-fit-measure="a"]');
      const inputB = dialog.querySelector('[data-fit-measure="b"]');
      const inputBust = dialog.querySelector('[data-fit-measure="bust"]');
      const heightEl = dialog.querySelector('[data-fit-height]');
      const weightEl = dialog.querySelector('[data-fit-weight]');
      const labelA = String(config.labelA || 'Mesure');
      const labelB = String(config.labelB || '');
      const el = (tag, className, text) => {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text != null) node.textContent = text;
        return node;
      };
      const trim = (value) => String(Math.round(value * 10) / 10);
      const both = (length) => Math.round(length.cm) + ' cm';
      const storeKey = 'bx-fit-v1';
      const load = () => {
        try {
          return JSON.parse(window.localStorage.getItem(storeKey)) || {};
        } catch (err) {
          return {};
        }
      };
      const save = (patch) => {
        try {
          window.localStorage.setItem(storeKey, JSON.stringify(Object.assign(load(), patch)));
        } catch (err) {
          /* Storage can be blocked. The finder works without it. */
        }
      };

      if (heightEl) {
        for (let inches = 56; inches <= 78; inches += 1) {
          const option = el('option', '', Math.round(inches * BxFit.IN) + ' cm');
          option.value = String(inches);
          heightEl.appendChild(option);
        }
      }

      const setUnit = (pane, unit) => {
        pane.querySelectorAll('[data-fit-unit]').forEach((button) => {
          const active = button.dataset.fitUnit === unit;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (pane === find) {
          fit.unit = unit;
          find.querySelectorAll('[data-fit-suffix]').forEach((suffix) => (suffix.textContent = unit));
          const sample = { a: fit.rows ? fit.rows[Math.floor(fit.rows.length / 2)].a[0] : 0 };
          const hint = (value) => 'ex. ' + Math.round(fit.tableUnit === unit ? value : unit === 'cm' ? value * BxFit.IN : value / BxFit.IN);
          if (inputA && fit.rows) inputA.placeholder = hint(sample.a);
          if (inputB && fit.rows && fit.rows[0].b) inputB.placeholder = hint(fit.rows[Math.floor(fit.rows.length / 2)].b[0]);
          if (inputBust) inputBust.placeholder = unit === 'cm' ? 'ex. 97' : 'ex. 38';
        } else {
          fit.chartUnit = unit;
        }
      };
      const setWeightUnit = (unit) => {
        fit.weightUnit = unit;
        dialog.querySelectorAll('[data-fit-wunit]').forEach((button) => {
          const active = button.dataset.fitWunit === unit;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (weightEl) weightEl.placeholder = unit === 'kg' ? 'ex. 75' : 'ex. 165';
      };

      const showError = (key, message) => {
        const node = dialog.querySelector('[data-fit-error="' + key + '"]');
        if (!node) return;
        node.hidden = !message;
        node.textContent = message || '';
        const input = key === 'weight' ? weightEl : dialog.querySelector('[data-fit-measure="' + key + '"]');
        if (input) input.classList.toggle('is-invalid', Boolean(message));
      };

      /* Reads one length field. Returns null when empty, false when unreadable. */
      const readField = (input, key, name) => {
        if (!input || !input.value.trim()) {
          showError(key, '');
          return null;
        }
        const length = BxFit.readLength(input.value, fit.unit);
        if (length.error) {
          showError(key, 'Cette mesure (' + name.toLowerCase() + ') semble incorrecte. Entre un nombre en centimètres (46 à 203).');
          return false;
        }
        showError(key, '');
        return length;
      };

      const renderChart = () => {
        const table = dialog.querySelector('[data-fit-table]');
        const caption = dialog.querySelector('[data-fit-chart-caption]');
        if (!table) return;
        const unit = fit.chartUnit;
        if (caption) caption.textContent = unit === 'cm' ? 'Mensurations en centimètres' : 'Mensurations en pouces';
        const show = (value, from) => {
          if (value === Infinity) return '';
          if (from === unit) return trim(value);
          return unit === 'cm' ? String(Math.round(value * BxFit.IN)) : trim(Math.round((value / BxFit.IN) * 2) / 2);
        };
        const span = (range, from) => (range[1] === Infinity ? show(range[0], from) + ' et plus' : range[0] === -Infinity ? 'Moins de ' + show(range[1], from) : show(range[0], from) + ' – ' + show(range[1], from));
        table.textContent = '';
        const head = el('tr');
        const body = [];
        if (fit.mode === 'body') {
          ['Taille', 'Tour de poitrine (' + unit + ')'].forEach((text) => head.appendChild(el('th', '', text)));
          fit.sizes.forEach((size, i) => {
            const steps = fit.body.bust;
            if (!steps.length) return;
            const range = [i === 0 ? -Infinity : steps[i - 1], i === steps.length ? Infinity : steps[i]];
            body.push({ size, cells: [size, span(range, 'in')] });
          });
        } else {
          const hasUs = fit.rows.some((row) => row.us);
          const hasB = Boolean(fit.rows[0].b);
          ['Taille'].concat(hasUs ? ['Équivalence'] : [], [labelA + ' (' + unit + ')'], hasB ? [labelB + ' (' + unit + ')'] : []).forEach((text) => head.appendChild(el('th', '', text)));
          fit.rows.forEach((row) => {
            body.push({ size: row.label, cells: [row.label].concat(hasUs ? [row.us] : [], [span(row.a, fit.tableUnit)], hasB ? [span(row.b, fit.tableUnit)] : []) });
          });
        }
        table.appendChild(head);
        body.forEach((row) => {
          const tr = el('tr', fit.result && fit.result.size === row.size ? 'is-match' : '');
          row.cells.forEach((text, i) => tr.appendChild(el(i === 0 ? 'th' : 'td', '', text)));
          if (i0(row)) tr.setAttribute('aria-current', 'true');
          table.appendChild(tr);
        });
      };
      const i0 = (row) => Boolean(fit.result && fit.result.size === row.size);

      const sizeAvailable = (size) => this.variants.some((variant) => variant.available && variant.options[this.sizePosition - 1] === size);

      const render = (result) => {
        fit.result = result;
        resultEl.textContent = '';
        resultEl.hidden = !result;
        resultEl.classList.toggle('is-none', Boolean(result && !result.size));
        if (!result) {
          applyButton.disabled = true;
          applyButton.textContent = fit.mode === 'body' ? 'Entre ta taille et ton poids' : 'Entre ton ' + labelA.toLowerCase();
          renderChart();
          return;
        }
        if (result.size) {
          const top = el('div', 'bx-fit__answer');
          top.appendChild(el('span', 'bx-fit__lead', 'Ta taille'));
          top.appendChild(el('strong', 'bx-fit__size', result.size));
          resultEl.appendChild(top);
        } else {
          resultEl.appendChild(el('p', 'bx-fit__none', result.title));
        }
        if (result.echo) resultEl.appendChild(el('p', 'bx-fit__echo', result.echo));
        if (result.meter) {
          const meter = el('div', 'bx-fit__meter');
          const bar = el('div', 'bx-fit__bar');
          const dot = el('span', 'bx-fit__dot');
          dot.style.left = Math.min(96, Math.max(4, result.meter.position * 100)) + '%';
          bar.appendChild(dot);
          meter.appendChild(bar);
          const ends = el('div', 'bx-fit__ends');
          ends.appendChild(el('span', '', result.meter.min));
          ends.appendChild(el('span', '', 'Plage ' + result.size));
          ends.appendChild(el('span', '', result.meter.max));
          meter.appendChild(ends);
          resultEl.appendChild(meter);
        }
        if (result.notes.length) {
          const list = el('ul', 'bx-fit__notes');
          result.notes.forEach((note) => list.appendChild(el('li', '', note)));
          resultEl.appendChild(list);
        }
        if (result.size) {
          const count = this.inline ? this.tier.units : 1;
          applyButton.disabled = false;
          applyButton.textContent = count > 1 ? 'Choisir le ' + result.size + ' pour les ' + count + ' articles' : 'Choisir le ' + result.size;
        } else {
          applyButton.disabled = true;
          applyButton.textContent = 'Aucune taille correspondante';
        }
        renderChart();
      };

      const computeChart = () => {
        const a = readField(inputA, 'a', labelA);
        const b = inputB ? readField(inputB, 'b', labelB) : null;
        if (a === false || b === false || !a) return render(null);
        const switched = a.switched || (b && b.switched);
        if (switched) setUnit(find, a.switched ? a.unit : b.unit);
        const rows = fit.rows;
        const outcome = BxFit.fromChart(rows, BxFit.native(a, fit.tableUnit), b ? BxFit.native(b, fit.tableUnit) : null);
        const notes = [];
        const lowerA = labelA.toLowerCase();
        const lowerB = labelB.toLowerCase();
        const echo = labelA + ' ' + both(a) + (b ? '  ·  ' + labelB + ' ' + both(b) : '');
        if (switched) notes.push('Nous avons lu ta mesure en ' + (a.switched ? a.unit : b.unit) + '. Vérifie qu’elle est correcte.');
        const unitText = (value) => (fit.tableUnit === fit.unit ? trim(value) : fit.unit === 'cm' ? String(Math.round(value * BxFit.IN)) : trim(Math.round((value / BxFit.IN) * 2) / 2)) + ' ' + fit.unit;
        if (outcome.status === 'above') {
          const last = rows[rows.length - 1];
          const key = outcome.driver;
          return render({ size: null, title: 'Nous n’avons pas encore ta taille dans ce modèle.', echo, notes: notes.concat(['Notre plus grande taille, ' + last.label + ', convient jusqu’à un ' + (key === 'a' ? lowerA : lowerB) + ' de ' + unitText(last[key][1]) + '. We would rather tell you than send something that will not fit. Write to us and we will help.']) });
        }
        const row = rows[outcome.index];
        const driverName = outcome.driver === 'a' ? lowerA : lowerB;
        if (outcome.status === 'below') notes.push('Tu es en dessous de notre plus petite taille. Le ' + row.label + ' est le plus proche et peut être un peu ample.');
        if (outcome.status === 'between') notes.push('Ton ' + driverName + ' est entre le ' + rows[outcome.lower].label + ' et le ' + row.label + '. Nous avons choisi le ' + row.label + ' pour ne pas serrer.');
        if (outcome.status === 'edge') notes.push('Ton ' + driverName + ' est pile entre le ' + rows[outcome.lower].label + ' et le ' + row.label + '. Nous avons choisi le ' + row.label + ' pour ne pas serrer.');
        if (outcome.raised) notes.push('Ton ' + lowerB + ' demande plus d’aisance que ton ' + lowerA + ' : nous sommes montés au ' + row.label + '.');
        const next = rows[outcome.index + 1];
        if (outcome.status === 'in' && outcome.position >= 0.8 && next) notes.push('Tu es en haut du ' + row.label + '. Tu préfères plus d’aisance ? Le ' + next.label + ' ira aussi.');
        if (inputB && !b && rows[0].b) notes.push('Ajoute ton ' + lowerB + ' pour un résultat plus précis.');
        if (!sizeAvailable(row.label)) notes.push('Le ' + row.label + ' est en rupture pour le moment.');
        const range = row[outcome.driver];
        const meter = (outcome.status === 'in' || outcome.status === 'edge') && range[1] !== Infinity ? { position: outcome.position || 0, min: unitText(range[0]), max: unitText(range[1]) } : null;
        const saved = {};
        saved[lowerA] = a.in;
        if (b) saved[lowerB] = b.in;
        saved.unit = fit.unit;
        save(saved);
        return render({ size: row.label, echo, meter, notes });
      };

      const computeBody = () => {
        const height = heightEl && heightEl.value ? Number(heightEl.value) : null;
        let weight = null;
        if (weightEl && weightEl.value.trim()) {
          weight = BxFit.readWeight(weightEl.value, fit.weightUnit);
          if (weight.error) {
            showError('weight', 'Ce poids semble incorrect. Entre des kilos (32 à 227).');
            weight = false;
          } else {
            showError('weight', '');
            if (weight.switched) setWeightUnit(weight.unit);
          }
        } else {
          showError('weight', '');
        }
        const bust = readField(inputBust, 'bust', 'tour de poitrine');
        if (bust && bust.switched) setUnit(find, bust.unit);
        if (!height || !weight || bust === false) return render(null);
        const outcome = BxFit.fromBody(fit.body, height, weight.lb, bust ? bust.in : null);
        const size = fit.sizes[outcome.index];
        const notes = [];
        const echo = Math.round(height * BxFit.IN) + ' cm  ·  ' + Math.round(weight.kg) + ' kg' + (bust ? '  ·  Poitrine ' + both(bust) : '');
        if ((bust && bust.switched) || weight.switched) notes.push('Nous avons adapté l’unité à ta saisie. Vérifie les valeurs ci-dessus.');
        if (outcome.raised) notes.push('Taille au-dessus pour ta poitrine, qui demande plus d’aisance que ta taille et ton poids seuls.');
        else if (bust) notes.push('Selon ta taille, ton poids et ton tour de poitrine.');
        else notes.push('Selon ta taille et ton poids. Ajoute ton tour de poitrine pour plus de précision.');
        if (outcome.top) notes.push('Le ' + size + ' est notre plus grande taille. Si tu es bien au-dessus, écris-nous avant de commander.');
        if (!sizeAvailable(size)) notes.push('Le ' + size + ' est en rupture pour le moment.');
        save({ height, lb: weight.lb, weightUnit: fit.weightUnit, bust: bust ? bust.in : undefined, unit: fit.unit });
        return render({ size, echo, meter: null, notes });
      };

      setWeightUnit(fit.weightUnit);
      const compute = () => (fit.mode === 'body' ? computeBody() : computeChart());

      const prefill = () => {
        const saved = load();
        const put = (input, inches) => {
          if (!input || input.value || !(inches > 0)) return;
          input.value = fit.unit === 'cm' ? String(Math.round(inches * BxFit.IN)) : trim(inches);
        };
        if (saved.unit === 'cm' || saved.unit === 'in') setUnit(find, saved.unit);
        put(inputA, saved[labelA.toLowerCase()]);
        put(inputB, saved[labelB.toLowerCase()]);
        put(inputBust, saved.bust);
        if (heightEl && !heightEl.value && saved.height) heightEl.value = String(saved.height);
        if (weightEl && !weightEl.value && saved.lb > 0) {
          if (saved.weightUnit === 'kg') setWeightUnit('kg');
          weightEl.value = String(Math.round(fit.weightUnit === 'kg' ? saved.lb * BxFit.LB : saved.lb));
        }
      };

      const showTab = (name) => {
        dialog.querySelectorAll('[data-fit-tab]').forEach((tab) => {
          const active = tab.dataset.fitTab === name;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        find.hidden = name !== 'find';
        chart.hidden = name !== 'chart';
      };
      const tabs = Array.from(dialog.querySelectorAll('[data-fit-tab]'));
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => showTab(tab.dataset.fitTab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          const other = tabs[(index + 1) % tabs.length];
          showTab(other.dataset.fitTab);
          other.focus();
        });
      });

      const zone = (name) => dialog.querySelectorAll('.bx-fit__band').forEach((band) => band.classList.toggle('is-active', band.dataset.zone === name));
      dialog.querySelectorAll('[data-fit-zone]').forEach((field) => field.addEventListener('focusin', () => zone(field.dataset.fitZone)));
      const firstZone = dialog.querySelector('[data-fit-zone]');
      if (firstZone) zone(firstZone.dataset.fitZone);

      const open = () => {
        prefill();
        compute();
        showTab('find');
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        document.documentElement.classList.add('bx-fit-open');
        const first = heightEl || inputA;
        if (first && !first.value) first.focus({ preventScroll: true });
      };
      const close = () => {
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      };
      dialog.addEventListener('close', () => document.documentElement.classList.remove('bx-fit-open'));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });
      dialog.querySelectorAll('[data-fit-close]').forEach((button) => button.addEventListener('click', close));
      /* Openers are re-created with the bundle rows, so the click is caught on the buy box. */
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-fit-open]')) open();
      });

      [inputA, inputB, inputBust, weightEl].forEach((input) => {
        if (input) input.addEventListener('input', compute);
      });
      if (heightEl) heightEl.addEventListener('change', compute);
      /* Switching the unit converts what is already typed, so the measurement itself never changes. */
      find.querySelectorAll('[data-fit-unit]').forEach((button) => button.addEventListener('click', () => {
        const next = button.dataset.fitUnit;
        if (next !== fit.unit) {
          [inputA, inputB, inputBust].forEach((input) => {
            if (!input || !input.value.trim()) return;
            const length = BxFit.readLength(input.value, fit.unit);
            if (length.error || length.switched) return;
            input.value = next === 'cm' ? String(Math.round(length.cm)) : trim(length.in);
          });
        }
        setUnit(find, next);
        compute();
      }));
      chart.querySelectorAll('[data-fit-unit]').forEach((button) => button.addEventListener('click', () => {
        setUnit(chart, button.dataset.fitUnit);
        renderChart();
      }));
      dialog.querySelectorAll('[data-fit-wunit]').forEach((button) => button.addEventListener('click', () => {
        const next = button.dataset.fitWunit;
        if (next !== fit.weightUnit && weightEl && weightEl.value.trim()) {
          const weight = BxFit.readWeight(weightEl.value, fit.weightUnit);
          if (!weight.error && !weight.switched) weightEl.value = String(Math.round(next === 'kg' ? weight.kg : weight.lb));
        }
        setWeightUnit(next);
        compute();
      }));

      applyButton.addEventListener('click', () => {
        if (!fit.result || !fit.result.size) return;
        const size = fit.result.size;
        const index = this.sizePosition - 1;
        if (this.inline) {
          this.units.forEach((unit) => (unit[index] = size));
        } else {
          const radio = Array.from(this.querySelectorAll('[data-option="' + this.sizePosition + '"] [data-option-input]')).find((item) => item.value === size);
          if (!radio) return;
          this.querySelectorAll('.bx-pill').forEach((pill) => pill.classList.remove('is-recommended'));
          radio.checked = true;
          radio.closest('label').classList.add('is-recommended');
          this.units[0] = this.readMainOptions();
        }
        this.fitSize = size;
        this.update();
        this.querySelectorAll('[data-fit-label]').forEach((label) => {
          label.textContent = 'Ta taille : ' + size;
          label.closest('.bx-fit-link').classList.add('is-done');
        });
        close();
      });

      setUnit(find, 'cm');
      setUnit(chart, 'cm');
      render(null);
    }

    /* Re-renders the theme cart drawer with the fresh cart and opens it. Returns false when the page has no drawer. */
    async openCartDrawer() {
      try {
        const wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (!wrapper || !document.getElementById('cart-drawer')) return false;
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(root + '?sections=cart-drawer-section');
        if (!response.ok) return false;
        const html = (await response.json())['cart-drawer-section'];
        if (!html) return false;
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-cart-drawer-section');
        if (!fresh || !fresh.querySelector('#cart-drawer')) return false;
        wrapper.innerHTML = fresh.innerHTML;
        await customElements.whenDefined('theme-drawer');
        const drawer = document.getElementById('cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') return false;
        drawer.open();
        document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach((el) => {
          const badge = fresh.querySelector('.theme-drawer__badge');
          if (badge) el.textContent = badge.textContent.trim();
        });
        return true;
      } catch (err) {
        return false;
      }
    }

    async onSubmit(event) {
      if (!window.fetch) return;
      event.preventDefault();
      const tier = this.tier;
      const error = this.querySelector('[data-error]');
      if (error) error.hidden = true;
      if (this.inline && !this.complete) {
        this.showMissing = true;
        this.update();
        if (error) {
          const label = this.querySelector('[data-submit-label]');
          error.textContent = (label && label.dataset.choose) || 'Choisis une taille pour chaque article.';
          error.hidden = false;
        }
        const missing = this.querySelector('.bx-row__select.is-missing, .bxsz__grid.is-missing');
        if (missing) missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      const chosen = this.units.slice(0, tier.units).map((options) => this.findVariant(options, options.style));
      if (chosen.some((variant) => !variant || !variant.available)) {
        if (error) {
          error.textContent = 'Une de tes sélections est en rupture. Choisis ' + (this.mixOn ? 'un autre modèle' : 'une autre couleur') + ' ou une autre taille.';
          error.hidden = false;
        }
        return;
      }
      /* Same variant picked several times becomes one line with a quantity. */
      const quantities = new Map();
      chosen.forEach((variant) => quantities.set(variant.id, (quantities.get(variant.id) || 0) + 1));
      const items = Array.from(quantities, ([id, quantity]) => {
        const item = { id, quantity };
        if (tier.units > 1 && tier.title) item.properties = { _bundle: tier.title };
        return item;
      });

      this.querySelectorAll('[data-gift]:not(.is-locked)[data-variant-id]').forEach((gift) => {
        items.push({ id: Number(gift.dataset.variantId), quantity: 1, properties: { _gift: 'true' } });
      });
      this.submitButtons.forEach((button) => (button.disabled = true));
      const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      try {
        if (this.dataset.replaceCart === 'true') {
          await fetch('/cart/clear.js', { method: 'POST', headers });
        }
        const response = await fetch('/cart/add.js', { method: 'POST', headers, body: JSON.stringify({ items }) });
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Impossible d’ajouter au panier');
        }
        if (window.bxCart) {
          await window.bxCart.open();
          this.submitButtons.forEach((button) => (button.disabled = false));
          return;
        }
        const after = this.dataset.afterAdd;
        if (after === 'drawer' && (await this.openCartDrawer())) {
          this.submitButtons.forEach((button) => (button.disabled = false));
          return;
        }
        window.location.href = after === 'checkout' ? '/checkout' : this.dataset.cartUrl || '/cart';
      } catch (err) {
        this.submitButtons.forEach((button) => (button.disabled = false));
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
      }
    }

    /* Small image of a color, taken from the gallery image whose alt text starts with the color name. */
    colorImage(color) {
      if (!this.colorImages) {
        this.colorImages = {};
        this.querySelectorAll('[data-gallery] [data-alt]').forEach((slide) => {
          const img = slide.querySelector('img');
          if (img) this.colorImages[slide.dataset.alt] = (img.currentSrc || img.src || '').replace(/([?&])width=\d+/, '$1width=120');
        });
      }
      const prefix = String(color || '').toLowerCase() + ' ';
      const key = Object.keys(this.colorImages).find((alt) => alt.startsWith(prefix));
      return key ? this.colorImages[key] : '';
    }

    /* Variants without their own image: jump to the first gallery image whose alt text starts with the color name. */
    showColor(color) {
      const gallery = this.querySelector('[data-gallery]');
      if (!gallery || !color || color === this.lastColor) return;
      this.lastColor = color;
      const prefix = String(color).toLowerCase() + ' ';
      const slide = Array.from(gallery.children).find((item) => (item.dataset.alt || '').startsWith(prefix));
      if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.children[0].offsetLeft, behavior: 'smooth' });
    }

    showMedia(mediaId) {
      const gallery = this.querySelector('[data-gallery]');
      if (!gallery) return;
      const slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.children[0].offsetLeft, behavior: 'smooth' });
    }

    /* Full-screen viewer: tap an image to open it, tap again to zoom where you tapped, drag to pan. */
    initZoom() {
      const dialog = this.querySelector('[data-zoom-dialog]');
      const openers = Array.from(this.querySelectorAll('[data-zoom-open]'));
      if (!dialog || !openers.length) return;
      const stage = dialog.querySelector('[data-zoom-stage]');
      const image = dialog.querySelector('[data-zoom-img]');
      const count = dialog.querySelector('[data-zoom-count]');
      const hint = dialog.querySelector('[data-zoom-hint]');
      const sources = openers.map((button) => {
        const thumb = button.querySelector('img');
        return { src: button.dataset.zoomSrc, thumb, alt: (thumb && thumb.alt) || '' };
      });
      let index = 0;
      let returnFocus = null;
      const unzoom = () => {
        dialog.classList.remove('is-zoomed');
        image.style.width = '';
        stage.scrollTo(0, 0);
        hint.textContent = 'Touche l’image pour zoomer';
      };
      const show = (next) => {
        index = (next + sources.length) % sources.length;
        unzoom();
        const item = sources[index];
        const current = index;
        /* Show the gallery image straight away, then swap in the sharp one when it has loaded. */
        const quick = item.thumb && item.thumb.complete && item.thumb.currentSrc;
        image.src = quick || item.src;
        image.alt = item.alt;
        if (quick && quick !== item.src) {
          const sharp = new Image();
          sharp.onload = () => {
            if (index === current) image.src = item.src;
          };
          sharp.src = item.src;
        }
        count.textContent = index + 1 + ' / ' + sources.length;
      };
      const open = (start, opener) => {
        returnFocus = opener;
        show(start);
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        document.documentElement.classList.add('bx-zoom-open');
      };
      const close = () => {
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      };
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('bx-zoom-open');
        unzoom();
        if (returnFocus) returnFocus.focus({ preventScroll: true });
      });
      openers.forEach((button, i) => button.addEventListener('click', () => open(i, button)));
      dialog.querySelector('[data-zoom-close]').addEventListener('click', close);
      dialog.querySelectorAll('[data-zoom-step]').forEach((button) => button.addEventListener('click', () => show(index + Number(button.dataset.zoomStep))));
      image.addEventListener('click', (event) => {
        if (dialog.classList.contains('is-zoomed')) {
          unzoom();
          return;
        }
        const box = image.getBoundingClientRect();
        const x = (event.clientX - box.left) / box.width;
        const y = (event.clientY - box.top) / box.height;
        /* Zoom so the image is about 2.6 times as wide as the screen: small labels become readable. */
        const natural = image.naturalWidth || box.width * 2;
        const width = Math.max(box.width * 2, Math.min(stage.clientWidth * 2.6, natural * 2));
        dialog.classList.add('is-zoomed');
        image.style.width = Math.round(width) + 'px';
        const height = width * (image.naturalHeight / image.naturalWidth || 1);
        stage.scrollLeft = Math.max(0, x * width - stage.clientWidth / 2);
        stage.scrollTop = Math.max(0, y * height - stage.clientHeight / 2);
        hint.textContent = 'Glisse pour déplacer, touche pour dézoomer';
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') show(index + 1);
        if (event.key === 'ArrowLeft') show(index - 1);
      });
      /* Swipe left or right when not zoomed to change image. */
      let startX = null;
      stage.addEventListener('touchstart', (event) => {
        startX = event.touches.length === 1 && !dialog.classList.contains('is-zoomed') ? event.touches[0].clientX : null;
      }, { passive: true });
      stage.addEventListener('touchend', (event) => {
        if (startX === null || !event.changedTouches.length) return;
        const delta = event.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(delta) > 50 && sources.length > 1) show(index + (delta < 0 ? 1 : -1));
      }, { passive: true });
    }

    initGallery() {
      const gallery = this.querySelector('[data-gallery]');
      const thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      if (!gallery || !thumbs.length) return;
      const slides = Array.from(gallery.children);
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const slide = slides[Number(thumb.dataset.thumb)];
          if (slide) gallery.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        });
      });
      let frame;
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const position = gallery.scrollLeft + slides[0].offsetLeft;
          let index = 0;
          slides.forEach((slide, i) => {
            if (Math.abs(slide.offsetLeft - position) < Math.abs(slides[index].offsetLeft - position)) index = i;
          });
          thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
        });
      }, { passive: true });
    }

    initSticky() {
      const sticky = this.querySelector('[data-sticky]');
      const submit = this.querySelector('[data-submit]');
      if (!sticky || !submit || !('IntersectionObserver' in window)) return;
      /* Hide the bar while any part of the offer (tiers, item rows, button) is on screen,
         so it never covers the color and size pickers. */
      const watched = [this.querySelector('.mp-offer__tiers'), this.querySelector('[data-options]'), submit].filter(Boolean);
      const visible = new Set();
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)));
        sticky.hidden = visible.size > 0;
      });
      watched.forEach((el) => io.observe(el));
      /* The sticky button brings the shopper back to the offer instead of adding blindly. */
      const go = sticky.querySelector('[data-sticky-go]');
      if (go) {
        go.addEventListener('click', () => {
          const target = this.querySelector('.mp-offer__tiers') || this.querySelector('[data-options]') || this.form;
          const top = target.getBoundingClientRect().top + window.scrollY - 90;
          const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
        });
      }
    }

    initShipDate() {
      const el = this.querySelector('[data-ships]');
      if (!el || !el.dataset.template) return;
      const date = new Date();
      let days = Number(this.dataset.shipDays || 1);
      while (days > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) days -= 1;
      }
      while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
      const label = date.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
      el.textContent = el.dataset.template.replace('[date]', label);
    }

    initCountdown() {
      const el = this.querySelector('[data-countdown]');
      if (!el) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(24, 0, 0, 0);
        const left = Math.max(0, Math.floor((end - now) / 1000));
        el.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  if (!customElements.get('bx-buy-box')) customElements.define('bx-buy-box', BxBuyBox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-product"] && !Shopify.designMode) return;
  try {
    
  class MpBuyBox extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-form]');
      if (!this.form) return;
      this.variantInput = this.querySelector('[data-variant-input]');
      this.planInput = this.querySelector('[data-plan-input]');
      this.subInput = this.querySelector('[data-sub-input]');
      this.subToggle = this.querySelector('[data-sub-toggle]');
      this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
      this.submitButtons = Array.from(this.querySelectorAll('[data-submit], [data-sticky-submit]'));

      this.tiers.forEach((input) => input.addEventListener('change', () => this.update()));
      this.querySelectorAll('[data-flavor]').forEach((radio) => radio.addEventListener('change', () => this.setFlavor(radio.value)));
      this.flavorValues = Array.from(this.querySelectorAll('[data-flavor]')).map((radio) => radio.value);
      const firstFlavor = this.querySelector('[data-flavor]:checked');
      this.unitFlavors = new Array(10).fill(firstFlavor ? firstFlavor.value : this.flavorValues[0]);

      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      // Apps (cart upsell drawers) hijack native product-form submits and post only the single variant.
      // Our buttons become plain buttons so only our pack/bundle logic adds to cart.
      const ownSubmit = (event) => { event.preventDefault(); event.stopImmediatePropagation(); this.onSubmit(event); };
      const submitButtons = new Set([...this.querySelectorAll('[data-submit], [data-sticky-submit]')]);
      if (this.form.id) document.querySelectorAll(`[form="${this.form.id}"]`).forEach((b) => submitButtons.add(b));
      submitButtons.forEach((button) => { button.type = 'button'; button.addEventListener('click', ownSubmit, true); });
      this.form.addEventListener('submit', ownSubmit, true);
      const once = this.querySelector('[data-buy-once]');
      if (once) {
        once.addEventListener('click', () => {
          this.buyOnce = true;
          this.form.requestSubmit();
        });
      }

      this.update();
      this.initGallery();
      this.initSticky();
      this.initShipDate();
      this.initCountdown();
    }

    setFlavor(flavor) {
      this.tiers.forEach((input) => {
        if (!input.dataset.flavors) return;
        try {
          const match = JSON.parse(input.dataset.flavors)[flavor];
          if (!match) return;
          input.value = String(match.id);
          input.disabled = !match.a;
          input.closest('.mp-tier').classList.toggle('is-soldout', !match.a);
        } catch (err) {
          /* Keep the current variant if the map cannot be read. */
        }
      });
      const label = this.querySelector('[data-flavor-label]');
      if (label) label.textContent = flavor;
      this.update();
    }

    get selected() {
      return this.tiers.find((input) => input.checked) || this.tiers[0];
    }

    flavorMap(tier) {
      try { return JSON.parse(tier.dataset.flavors || 'null'); } catch (err) { return null; }
    }

    /* One flavor choice per unit, inside the selected offer. The pack variant follows the most chosen flavor; the mix is sent as a line property. */
    renderFlavors() {
      if (!this.flavorValues || !this.flavorValues.length) return;
      const unitLabel = this.dataset.unitLabel || 'sachet';
      this.tiers.forEach((tier) => {
        const box = tier.closest('.mp-tier').querySelector('[data-tier-flavors]');
        if (!box) return;
        if (!tier.checked) { box.hidden = true; box.innerHTML = ''; return; }
        const map = this.flavorMap(tier) || {};
        const units = Number(tier.dataset.units || 1);
        box.innerHTML = '';
        const title = document.createElement('span');
        title.className = 'mp-tier__flavors-title';
        title.textContent = units > 1 ? 'Choisis la saveur de chaque ' + unitLabel : 'Choisis ta saveur';
        box.appendChild(title);
        for (let i = 0; i < units; i++) {
          const row = document.createElement('span');
          row.className = 'mp-tier__flavor-row';
          const name = document.createElement('span');
          name.textContent = unitLabel.charAt(0).toUpperCase() + unitLabel.slice(1) + ' ' + (i + 1);
          const select = document.createElement('select');
          select.setAttribute('aria-label', name.textContent);
          this.flavorValues.forEach((value) => {
            const option = document.createElement('option');
            option.value = value;
            const available = !map[value] || map[value].a;
            option.textContent = value + (available ? '' : ' (Rupture de stock)');
            option.disabled = !available;
            option.selected = value === this.unitFlavors[i];
            select.appendChild(option);
          });
          select.addEventListener('click', (event) => event.stopPropagation());
          select.addEventListener('change', () => { this.unitFlavors[i] = select.value; this.applyFlavors(); });
          row.appendChild(name);
          row.appendChild(select);
          box.appendChild(row);
        }
        box.hidden = false;
      });
      this.applyFlavors();
    }

    applyFlavors() {
      const tier = this.selected;
      const map = tier && this.flavorMap(tier);
      if (!map) return;
      const units = Number(tier.dataset.units || 1);
      const counts = {};
      this.unitFlavors.slice(0, units).forEach((f) => (counts[f] = (counts[f] || 0) + 1));
      const main = Object.keys(counts).sort((a, b) => counts[b] - counts[a])[0];
      if (map[main]) { tier.value = String(map[main].id); this.variantInput.value = tier.value; }
      this.flavorMix = Object.keys(counts).length > 1
        ? Object.keys(counts).map((f) => counts[f] + '× ' + f).join(', ')
        : '';
      const label = this.querySelector('[data-flavor-label]');
      if (label) label.textContent = main;
    }

    update() {
      const input = this.selected;
      if (!input) return;
      if (input !== this.lastTier) { this.lastTier = input; this.renderFlavors(); }
      const hasPlan = Boolean(input.dataset.subPrice);
      const subscribed = Boolean(this.subInput && this.subInput.checked && hasPlan);
      const units = Number(input.dataset.units || 1);
      let subPrice = input.dataset.subPrice;
      let planId = input.dataset.plan || '';
      if (input.dataset.plans) {
        try {
          const map = JSON.parse(input.dataset.plans);
          const re = new RegExp('(^|\\D)' + units + '(\\D|$)');
          const hit = Object.keys(map).find((id) => re.test(map[id].n)) || Object.keys(map)[0];
          if (hit) { planId = hit; subPrice = map[hit].p; }
        } catch (err) { /* keep defaults */ }
      }
      this.refillText = units > 1 ? 'Livré tous les ' + units + ' mois' : 'Livré tous les mois';
      this.tiers.forEach((tier) => {
        const card = tier.closest('.mp-tier');
        card.classList.toggle('is-selected', tier === input);
        const showSub = Boolean(this.subInput && this.subInput.checked && tier.dataset.subPrice);
        card.querySelectorAll('[data-sub]').forEach((el) => (el.hidden = !showSub));
        card.querySelectorAll('[data-once]').forEach((el) => {
          const twin = el.parentElement.querySelector(':scope > [data-sub]');
          el.hidden = showSub && Boolean(twin);
        });
      });

      const giftsBox = this.querySelector('[data-gifts-box]');
      if (giftsBox) {
        const src = input.closest('.mp-tier').querySelector('.mp-tier__gifts');
        const html = src ? src.innerHTML.trim() : '';
        giftsBox.querySelector('[data-gifts-list]').innerHTML = html;
        giftsBox.hidden = !html;
      }
      this.variantInput.value = input.value;
      if (this.planInput) {
        this.planInput.disabled = !(subscribed && planId);
        this.planInput.value = subscribed ? planId : '';
      }
      const subInfo = this.querySelector('[data-sub-info]');
      if (subInfo) {
        subInfo.hidden = !hasPlan;
        const refill = subInfo.querySelector('[data-sub-refill]');
        if (refill) refill.textContent = this.refillText;
        const oncePrice = subInfo.querySelector('[data-once-price]');
        if (oncePrice) oncePrice.textContent = input.dataset.price;
      }
      if (this.subToggle) {
        this.subToggle.hidden = !hasPlan;
        const note = this.subToggle.querySelector('[data-sub-note]');
        if (note && input.dataset.subNote && !note.dataset.fixed) {
          if (!note.dataset.base) note.dataset.base = note.textContent.trim();
          note.textContent = input.dataset.subNote + (note.dataset.base ? ' · ' + note.dataset.base : '');
        }
      }

      const price = subscribed ? subPrice : input.dataset.price;
      const priceEl = this.querySelector('[data-submit-price]');
      if (priceEl) priceEl.textContent = '– ' + price;
      const stickyTitle = this.querySelector('[data-sticky-title]');
      const stickyPrice = this.querySelector('[data-sticky-price]');
      if (stickyTitle) stickyTitle.textContent = input.dataset.title;
      if (stickyPrice) stickyPrice.textContent = price + (subscribed ? ' · abonnement' : '');
    }

    /* Re-renders the theme cart drawer with the fresh cart and opens it. Returns false when the page has no drawer. */
    async openCartDrawer() {
      try {
        const wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (!wrapper || !document.getElementById('cart-drawer')) return false;
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(root + '?sections=cart-drawer-section');
        if (!response.ok) return false;
        const html = (await response.json())['cart-drawer-section'];
        if (!html) return false;
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-cart-drawer-section');
        if (!fresh || !fresh.querySelector('#cart-drawer')) return false;
        wrapper.innerHTML = fresh.innerHTML;
        await customElements.whenDefined('theme-drawer');
        const drawer = document.getElementById('cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') return false;
        drawer.open();
        document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach((el) => {
          const badge = fresh.querySelector('.theme-drawer__badge');
          if (badge) el.textContent = badge.textContent.trim();
        });
        return true;
      } catch (err) {
        return false;
      }
    }

    async onSubmit(event) {
      if (!window.fetch) return;
      event.preventDefault();
      const input = this.selected;
      const subscribed = Boolean(this.subInput && this.subInput.checked && input.dataset.subPrice && !this.buyOnce);
      const planId = this.planInput && !this.planInput.disabled ? this.planInput.value : '';
      this.buyOnce = false;
      if (this.flavorValues && this.flavorValues.length) this.applyFlavors();
      const main = { id: Number(input.value), quantity: 1 };
      if (this.flavorMix) main.properties = { Saveurs: this.flavorMix };
      if (subscribed && planId) main.selling_plan = Number(planId);
      else if (subscribed) main.properties = Object.assign({}, main.properties, { _abonnement: this.refillText });
      const items = [main];
      (input.dataset.gifts || '').split(',').filter(Boolean).forEach((id) => {
        items.push({ id: Number(id), quantity: 1, properties: { _gift: 'true', _parent_variant: String(input.value) } });
      });

      const error = this.querySelector('[data-error]');
      if (error) error.hidden = true;
      this.submitButtons.forEach((button) => (button.disabled = true));
      const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

      try {
        if (this.dataset.replaceCart === 'true') {
          await fetch('/cart/clear.js', { method: 'POST', headers });
        }
        const response = await fetch('/cart/add.js', { method: 'POST', headers, body: JSON.stringify({ items }) });
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Impossible d’ajouter au panier');
        }
        if (window.bxCart) {
          await window.bxCart.open();
          this.submitButtons.forEach((button) => (button.disabled = false));
          return;
        }
        const after = this.dataset.afterAdd;
        if (after === 'drawer' && (await this.openCartDrawer())) {
          this.submitButtons.forEach((button) => (button.disabled = false));
          return;
        }
        window.location.href = after === 'checkout' ? '/checkout' : this.dataset.cartUrl || '/cart';
      } catch (err) {
        this.submitButtons.forEach((button) => (button.disabled = false));
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
      }
    }

    initGallery() {
      const gallery = this.querySelector('[data-gallery]');
      const thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      if (!gallery || !thumbs.length) return;
      const slides = Array.from(gallery.children);
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const slide = slides[Number(thumb.dataset.thumb)];
          if (slide) gallery.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        });
      });
      let frame;
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const position = gallery.scrollLeft + slides[0].offsetLeft;
          let index = 0;
          slides.forEach((slide, i) => {
            if (Math.abs(slide.offsetLeft - position) < Math.abs(slides[index].offsetLeft - position)) index = i;
          });
          thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
        });
      }, { passive: true });
    }

    initSticky() {
      const sticky = this.querySelector('[data-sticky]');
      const submit = this.querySelector('[data-submit]');
      if (!sticky || !submit || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting;
      }).observe(submit);
    }

    initShipDate() {
      const el = this.querySelector('[data-ships]');
      if (!el || !el.dataset.template) return;
      const date = new Date();
      let days = Number(this.dataset.shipDays || 1);
      while (days > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) days -= 1;
      }
      while (date.getDay() === 0 || date.getDay() === 6) date.setDate(date.getDate() + 1);
      const label = date.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
      el.textContent = el.dataset.template.replace('[date]', label);
    }

    initCountdown() {
      const el = this.querySelector('[data-countdown]');
      if (!el) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(24, 0, 0, 0);
        const left = Math.max(0, Math.floor((end - now) / 1000));
        el.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  if (!customElements.get('mp-buy-box')) customElements.define('mp-buy-box', MpBuyBox);

  } catch(e) { console.error(e); }
})();
})();
